// src/graphql/queries/eventActionQueries.js

export const getEventActionBindings = () => `query GetEventActionBindings($eventType: String, $jobType: String, $companyId: String, $enabled: Boolean, $limit: Int, $offset: Int) {
    adminEventActionBindings(eventType: $eventType, jobType: $jobType, companyId: $companyId, enabled: $enabled, limit: $limit, offset: $offset) {
        items {
            id
            eventType
            jobType
            companyId
            paramMapping
            tenderIdField
            enabled
            description
            jobPriority
            condition
            createdAt
            updatedAt
            managedBy
            managedName
        }
        totalCount
    }
}`;

export const getEventActionBinding = () => `query GetEventActionBinding($id: String!) {
    adminEventActionBinding(id: $id) {
        id
        eventType
        jobType
        companyId
        paramMapping
        tenderIdField
        enabled
        description
        jobPriority
        condition
        createdAt
        updatedAt
        managedBy
        managedName
    }
}`;

export const getEventActionLogs = () => `query GetEventActionLogs($eventType: String, $bindingId: String, $status: String, $limit: Int, $offset: Int) {
    adminEventActionLogs(eventType: $eventType, bindingId: $bindingId, status: $status, limit: $limit, offset: $offset) {
        items {
            id
            eventType
            eventSource
            eventPayload
            bindingId
            jobId
            jobType
            tenderId
            status
            errorMessage
            createdAt
        }
        totalCount
    }
}`;

export const getEventActionStats = () => `query GetEventActionStats {
    adminEventActionStats {
        totalBindings
        enabledBindings
        disabledBindings
        totalEventsDispatched
        recentEventsDispatched
        eventTypeBreakdown {
            eventType
            count
        }
    }
}`;

export const getEventTypeSchemas = () => `query GetEventTypeSchemas {
    eventTypeSchemas {
        eventType
        category
        description
        source
        payload {
            name
            type
            description
        }
    }
}`;

export const getEventTypeSchema = () => `query GetEventTypeSchema($eventType: String!) {
    eventTypeSchema(eventType: $eventType) {
        eventType
        category
        description
        source
        payload {
            name
            type
            description
        }
    }
}`;
